import { Skeleton, SpinLoading } from "antd-mobile";

export interface LoadingProps {
    count: number;
}

export const Loading: React.FC<LoadingProps> = ({count} = {count: 1}) => {
    return (
        <div className="flex flex-col gap-2 p-2">
            {count && count > 0 && (
                <>
                    {Array.from({length: count}).map((_, index) => (
                        <div key={index}>
                            <Skeleton.Title animated />
                            <Skeleton.Paragraph lineCount={5} animated />
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};